import { render, staticRenderFns } from "./danxuan.vue?vue&type=template&id=7f8307f5&"
import script from "./danxuan.vue?vue&type=script&lang=ts&"
export * from "./danxuan.vue?vue&type=script&lang=ts&"
import style0 from "./danxuan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports